module.exports = __webpack_public_path__ + "static/media/indieFilmText.48846ed7.svg";